<template>
  <div id="School-edit">

      <IForm :label-width="130" ref="formInline" :model="edit" :elem="blackListElem" :rules="blackListRule" @on-submit="toSubmit" :submit="false" :showMessage="true">
        <div slot="extend">
          <Row>
            <Col span="24"><FormItem label="微信标识" prop="openid"><Input v-model.trim="edit.openid" type="text" placeholder="请输入微信标识" maxlength="50"/></FormItem></Col>
          </Row>
          <Row>
            <Col span="24"><FormItem label="ip" prop="ip"><Input v-model.trim="edit.ip" type="text" placeholder="请输入ip" maxlength="15"/></FormItem></Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="状态" prop="status">
                <Select v-model="edit.status">
                  <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="备注" prop="remarks"><Input v-model="edit.remarks" type="textarea" placeholder="请输入备注"/></FormItem>
            </Col>
          </Row>
        </div>
      </IForm>

  </div>
</template>
<script>
import { _get, _edit} from "@/services/manage/blackList";
export default {
  name: "BlackListEdit",
  data() {
    return {
      edit: {
        openid: "",
        ip: "",
        remarks: "",
        status: 1
      },
      init: "",
      statusList:[
        {label: '全部', value: ''},
        {label: '启用', value: 1},
        {label: '禁用', value: 2},
      ],
      blackListElem: [],
      blackListRule: {
        openid: [
          {required: true, message: '微信标识openid不能为空', trigger: 'blur'},
          {maxlength:50,message:"微信标识openid长度不能超过50个字",trigger: 'blur'}
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
            type:'number'
          }
        ]
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleModal(row) {
      this.$refs["formInline"].handleReset();
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      _get({id: row.id}).then(res =>{
        row = res.data;
        const edit = Object.assign({}, row);
        edit.types = edit.type.toString().split(",");
        this.edit = {
          ...edit,
        };
        this.$forceUpdate();
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      const payload = {
        ...this.edit,
      }
      _edit(payload).then(res => {
          if (res.errcode === 1) {
            this.$message.success("保存成功");
            this.$emit("on-submit", false);
          }else{
            this.$message.error(res.errmsg);
          }
        }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>

</style>
